import style from './TopupPage.css';
import Alert from '../../components/shared/Alert/Alert';
import List from '../../components/shared/List/List';
import ListItem from '../../components/shared/List/ListItem';
import Title from '../../components/shared/Typography/Title';
import useTranslation from '../../localization/i18n.context';
import Button from '../../components/shared/Button/Button';
import PhoneFilledIcon from '../../components/shared/Icons/PhoneFilledIcon';
import DepositFilledIcon from '../../components/shared/Icons/DepositFilledIcon';
import StoreFilledIcon from '../../components/shared/Icons/StoreFilledIcon';
import NavigationUtils from '../../utils/navigation.utils';
import { DeeplinkEvent } from '../../sdk/deeplink.event';
import LuckyDeeplink from '../../constants/lucky.deeplink';
import CardStatus from '../../constants/card.status';
import { renderIf } from '../../utils/render.utils';

const TopupMethods = [
  {
    icon: <PhoneFilledIcon className={style.icon} />,
    title: 'Instapay',
    subtitle: 'Instant',
    infoText: 'Free',
    type: 'instapay',
  },
  {
    icon: <DepositFilledIcon className={style.icon} />,
    title: 'ATM Deposit',
    subtitle: 'Instant',
    infoText: 'Free',
    type: 'atm',
  },
  {
    icon: <StoreFilledIcon className={style.icon} />,
    title: 'Fawry',
    subtitle: 'Instant',
    type: 'fawry',
  },
];

export default function TopupView({ settings }) {
  const { t } = useTranslation();
  const disabled =
    !settings.activationDate || settings.status === CardStatus.LOCKED;

  let availableMethods = settings?.posEnabled
    ? TopupMethods.slice(0, 2)
    : TopupMethods;
  return (
    <>
      <main className={style.main}>
        <Title
          text={t('How would you like to top up?')}
          className={style['page-title']}
        />

        {renderIf(
          disabled,
          <Alert
            type={Alert.Type.WARNING}
            className={style['disabled-message']}
            message={
              !settings.activationDate
                ? t('You need to have an active card to be able to top up')
                : settings.status === CardStatus.LOCKED
                ? t('Your card is locked. Unlock it to top up')
                : ''
            }
            hasIcon
          />,
        )}

        <List>
          {availableMethods.map(item => (
            <ListItem
              title={t(item.title)}
              subtitle={t(item.subtitle)}
              infoText={item.infoText ? t(item.infoText) : null}
              icon={item.icon}
              actionable
              size={ListItem.Size.SMALL}
              disabled={disabled}
              onClick={() => {
                if (disabled) {
                  return;
                }
                NavigationUtils.navigate(
                  `${NavigationUtils.Routes.TOPUP_DETAIL}/${item.type}`,
                );
              }}
            />
          ))}
        </List>
      </main>
      <div className="fixed-cta">
        <Button
          type={Button.Type.TERTIARY}
          onClick={() => {
            // TODO : it is required to change in the future when we implement another client.
            DeeplinkEvent.open(LuckyDeeplink.FAQS);
          }}
        >
          {t('FAQs')}
        </Button>
      </div>
    </>
  );
}
